import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type FC, type PropsWithChildren } from "react";

export const EducationPageContainer: FC<PropsWithChildren & PropsWithClassName> = ({ children, className }) => {
    return <div className={cn("flex w-full flex-col gap-6 md:mx-auto md:max-w-5xl", className)}>{children}</div>;
};
